/**
 * Le côté navigateur de Touch ID : on enchaîne l'API d'identité et
 * ``@simplewebauthn/browser``, qui consomme directement le JSON des options et
 * rend les ``…ResponseJSON`` que l'API attend.
 */

import {
  browserSupportsWebAuthn,
  startAuthentication,
  startRegistration,
  type PublicKeyCredentialCreationOptionsJSON,
  type PublicKeyCredentialRequestOptionsJSON,
} from "@simplewebauthn/browser";

import {
  completePasskeyRegistration,
  initiatePasskeySignIn,
  respondToPasskeyChallenge,
  startPasskeyRegistration,
  type AuthenticationResult,
} from "./cognitoIdp";

export function passkeysSupported(): boolean {
  return browserSupportsWebAuthn();
}

/** Connexion par Touch ID pour `email`. Rend les jetons ; ne touche pas au store OIDC. */
export async function authenticateWithPasskey(email: string): Promise<AuthenticationResult> {
  const username = email.trim();
  const { session, requestOptions } = await initiatePasskeySignIn(username);
  const credential = await startAuthentication({
    optionsJSON: requestOptions as PublicKeyCredentialRequestOptionsJSON,
  });
  return respondToPasskeyChallenge({ username, session, credential });
}

/**
 * Enrôle l'appareil courant. `accessToken` doit porter le scope admin (voir
 * `hasAdminScope`) : sans lui, l'API refuse dès la première requête.
 */
export async function registerThisDevice(accessToken: string): Promise<void> {
  const options = await startPasskeyRegistration(accessToken);
  const credential = await startRegistration({
    optionsJSON: options as PublicKeyCredentialCreationOptionsJSON,
  });
  await completePasskeyRegistration(accessToken, credential);
}
